import {MutationTree} from "vuex";
import {ProviderConnectionState} from "@/store/settings/provider_connections/types";

export const mutations: MutationTree<ProviderConnectionState> = {
  setProviderConnections: (state, payload) => {
    state.providerConnections = payload
  }
}